export const environment = {
    production: false,
    // En production, l'API est sur le même domaine, mais avec le préfixe /api
    apiUrl: 'http://localhost:3009',
    //apiUrl: 'https://app.wariflow.com/api/v1/ma-franchise',
    apiUrlInvoiceGenerated: 'https://app.wariflow.com/api/v1/ma-franchise',
    externaleAuthUrl: "https://platform.wariflow.com/account/platform/wariflow/login",
    versionNumber: "1.1.1",
    baseApiSpeedpresta: "https://api.speedpresta.com/api/v1/",
    customerUrl: "CUSTOMERS/RETRIEVE_ALL_FROM_KEY",
    userPlatformUrl: "USER/RETRIEVE_ALL_FROM_KEY",
    customerRoleUrl: "ROLES/RETRIEVE_ALL_FROM_KEY",
    platformSiteUrl: "SITE/RETRIEVE_ALL_FROM_KEY",
    customerWariflowUrl: "RETRIEVE_FROM_KEY",
    similarityUrl: "https://api.mimicx.ai/api/v1/WARIFLOW/document/similarity",
    settingsWariflowUrl:"CONFIG/RETRIEVE_FROM_KEY",
    shipmentPlatformUrl:"SHIPMENT_PER_DESTINATION/RETRIEVE_ALL_FROM_KEY",
    deliveryRetrieveUrl: "DELIVERY/RETRIEVE_ALL_FROM_KEY",
    productUrl: "PRODUCT/RETRIEVE_ALL_FROM_KEY",
    invoiceApiUrl: "https://app.wariflow.com/api/v1/billing/",
    speedprestaProxyUrl: "https://api.speedpresta.com/requests/get",
    productStockUrl: "PRODUCT_STOCK/RETRIEVE_ALL_FROM_KEY",
    productStockUpdateUrl: "PRODUCT_STOCK/UPDATE_ALL",
    // Ne JAMAIS mettre de token JWT ici. Utiliser .env.development (gitignored).
    devJwtToken: ""
};
